import * as React from 'react'
import * as classnames from 'classnames'

import * as styles from './menuChapter.css'

import { StoreComponent, injectStores } from '../../../store'
import { observer } from 'mobx-react'
import { observable, reaction } from 'mobx'
import { HashLink as Link } from 'react-router-hash-link'
import { ShowSectionsButton } from '../../common/elements/buttons'
import { ContentChapter } from '../../storydoc/storydocStoreContent'

interface IProps {
  chapter: ContentChapter
  isActive?: boolean
}

@injectStores
@observer
export class MenuChapter extends StoreComponent<IProps> {
  @observable expand = false

  element: HTMLDivElement | null = null

  constructor (props: any, context: any) {
    super(props, context)

    reaction(
      () => this.store.storeCommon.menu.open, (open: boolean) => {
        if (!open) this.expand = false
      }
    )
  }

  render () {
    // console.log('menuChapter props', this.props)
    let colorOverlay: JSX.Element | null = null
    colorOverlay = <div className={styles.colorOverlay} style={{ backgroundColor: this.store.storyDocContent.chapters[this.props.chapter.idx].color }}></div>

    const sections = []
    for (let i = 0; i < this.props.chapter.sections.length; i++) {

      let fillerHeight = 0
      if (this.store.storeCommon.currentStory.scrollerData.length > i + 1) {
        fillerHeight = Math.max(Math.min(this.store.storeCommon.currentStory.scrollerData[i + 1], 1.0), 0.0) * 100
      }
      let filler: JSX.Element | null = null
      if (this.store.breakpoints.desktop) {
        filler = <div className={ styles.sectionFiller } style={ this.store.storyDocUI.currentSlideIdx === this.props.chapter.idx ? { height: `${ fillerHeight }%` } : { height: 0 } }>
                 <div className={ styles.sectionTitleBlack }>{ this.props.chapter.sections[i].title }</div>
               </div>
      }

      sections.push(
          <Link
            to={ { pathname: `/story/${ this.props.chapter.uid }`, hash: this.props.chapter.sections[i].id } }
            className={ styles.section } key={ this.props.chapter.sections[i].id }
            replace={`/story/${ this.props.chapter.uid }` === this.store.storeRouter.location.pathname}
            >
            { this.store.breakpoints.phone && colorOverlay }
            { filler }
            <div className={styles.sectionTitle}>{this.props.chapter.sections[i].title.replace(/s-w/g,'s-W')}</div>
          </Link >
        )
    }

    let text: JSX.Element | null = null
    text = <div className={ classnames(styles.text, this.props.isActive ? styles.activeText : null) }>
               { this.props.chapter.idx > 0 ? `${ this.props.chapter.idx }  |  ${ this.props.chapter.title }` : 'Intro' }
             </div>

    return (
      <div
        // to={`/story/${chapter.id}`}
        key= { this.props.chapter.id }
        className= { classnames(styles.kapitelColumn, this.props.isActive ? styles.activeColumn : null) }
        ref={ elem => this.element = elem }
        >
        <div
          className={ styles.barItem }
          onClick={ () => {
            const pathname = `/story/${ this.props.chapter.uid }`
            // console.log(pathname, this.store.storeRouter.location.pathname)
            if (this.store.storeRouter.location.pathname !== pathname) this.store.storeRouter.push(pathname)
            else this.store.storeRouter.replace(pathname)
          }}
          >
          <div className={styles.barImage} style={{ backgroundImage: this.store.breakpoints.phone && this.props.chapter.urlMobileMenuThumb ? `url(${this.props.chapter.urlMobileMenuThumb})` : `url(${this.props.chapter.urlDesktopMenuThumb})` }}>
            { colorOverlay }
          </div>
          {this.store.breakpoints.desktop && <div className={ styles.barZone }>
          <div className={ classnames(styles.bar, this.props.isActive ? styles.active : null) }></div>
          </div> }
          { text }
          { this.store.breakpoints.phone && this.props.chapter.idx > 0 && <ShowSectionsButton className={ styles.showSectionsButton } onClick={ (e: any) => {
            e.stopPropagation()
            this.expand = !this.expand
            if (this.expand && this.element) {
              // this.element.scrollIntoView({ block: 'center', inline: 'center', behavior: 'smooth' })
              this.element.scrollTop = 50
            }
          }}/> }
        </div>
        { this.store.breakpoints.phone && this.expand && sections }
        { this.store.breakpoints.desktop && sections }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/common/header/menuChapter.tsx